import React from 'react'

const SUPPORT_HUB_URL =
  'https://diversitymark.org/diversity-mark-2-0-action-to-impact-resources/?preview=client'

const SupportHub = () => {
  return (
    <div style={{ width: '100%', height: 'calc(100vh - 140px)' }}>
      <iframe
        src={SUPPORT_HUB_URL}
        title="Support Hub"
        style={{ width: '100%', height: '100%', border: '0', borderRadius: 12 }}
        loading="lazy"
      />
    </div>
  )
}

export default SupportHub
